import script from "./ActiveCallView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActiveCallView.vue?vue&type=script&lang=ts&setup=true"

import "./ActiveCallView.vue?vue&type=style&index=0&id=7683eeea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7683eeea"]])

export default __exports__